import { render, staticRenderFns } from "./InitiatedBlockMember.vue?vue&type=template&id=332c6439"
import script from "./InitiatedBlockMember.vue?vue&type=script&lang=js"
export * from "./InitiatedBlockMember.vue?vue&type=script&lang=js"
import style0 from "./InitiatedBlockMember.vue?vue&type=style&index=0&id=332c6439&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports